
import { type ReceivedMessage } from '@livekit/components-react';

interface PreConnectMessageProps {
  messages?: ReceivedMessage[];
  className?: string;
}

export function PreConnectMessage(_props: PreConnectMessageProps) {
  // Message removed - agent greeting will be shown in transcript instead
  return null;
}
